import _ from 'lodash';
import { getMinGTMultiple, getMaxLTMultiple } from './integerUtility';

// 学習時間の階級の幅候補
const widthCandidates = [1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000];

// 学習時間の階級(どの範囲で分けるか)取得
const getTimeRangeData = (data) => {
  // データポイント数
  const size = data.length;
  if (!size) {
    return [];
  }

  // 何分割を目指すか
  const idealBins = (() => {
    if (size <= 1) {
      return 1;
    }
    if (size < 10) {
      return 2;
    }
    if (size < 20) {
      return 5;
    }
    return 10;
  })();

  const dataMax = _.max(data);
  const dataMin = _.min(data);
  const dataRange = dataMax - dataMin;
  // 理想の幅
  const idealWidth = dataRange / idealBins;

  // 幅候補の最大値
  const maxWidthCandidate = _.find(widthCandidates, candidate => candidate >= idealWidth) || _.max(widthCandidates);
  // 幅候補の最小値
  const minWidthCandidate = _.findLast(widthCandidates, candidate => candidate <= idealWidth) || _.min(widthCandidates);

  // 1つ1つの幅
  const width = Math.abs(maxWidthCandidate - idealWidth) < Math.abs(idealWidth - minWidthCandidate)
    ? maxWidthCandidate
    : minWidthCandidate;

  // 分布の最大値
  const max = getMinGTMultiple(dataMax, width);
  // 分布の最小値
  const min = getMaxLTMultiple(dataMin, width);
  // トータルの幅
  const range = max - min;
  // 実際の分割数
  const bins = Math.round(range / width);

  const rangeData = [];
  for (let i = 0; i < bins; i++) {
    const bottom = min + (i * width);
    const top = bottom + width;
    const middle = (bottom + top) / 2;

    rangeData.push({
      bottom,
      top,
      middle,
    });
  }

  return {
    rangeData,
    min,
    max,
    width,
  };
};

export default getTimeRangeData;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/portfolio/analysis/utils/getTimeRangeData.js